
import crypto from '@/common/resources/crypto.js'
import {UPDATE_CURRENT_PATH} from "../../store/mutation-types";
import store  from '@/store/index'
import _, { values } from 'lodash';
import swal from 'sweetalert2';

const ociUtils = {
// needed to set up as plugin, used by Vue to make it global in main
  install: function(Vue) {
    Object.defineProperty(Vue.prototype, '$ociUtils', { value: this });
  },

  global: {

    removeDuplicateLiabilities(allAppApps){
      for(let applicantIndex = 0;applicantIndex < allAppApps.length; applicantIndex++){
        let applicant = allAppApps[applicantIndex].applicant;
        let properties = [];
        let distinctLiabilities = [];
        let dynamicRentFound = false;
        let ociAssetsLiabilities = [];
        let ociAssetLiabilitiesRow = {
          asset: null,
          assetOptions: {expand: false},
          liabilities: [],
          options: {
            showBureauLiabilityDesc: false,
            dynamic: false
            },
        };
      if (applicant.assets) {
        // this.ociLog("Assets from State",applicant.assets)
        let allAssets = JSON.parse(JSON.stringify(applicant.assets));
        allAssets.sort((a, b) => (a.assetId > b.assetId) ? 1 : -1);
        // console.log("allAssets ",allAssets)
        for (let i=0; i<allAssets.length;i++){
          // console.log("initial: " + i)
          allAssets[i].index = i;
          if(allAssets[i].downPayment!==null){
            allAssets[i].downPayment.mortgage = {mortgageId:allAppApps[0].loanApplication.mortgage.mortgageId}
          }
          if (allAssets[i].assetType === 'Property' || allAssets[i].otherProperty!==null) {
            // allAssets[i].index = i;
            properties.push(allAssets[i]);
            // this.ociLog("properties");
            // this.ociLog(properties);
            if ( allAssets[i].assetLiabilities.length > 0) { //check if there are associated liabilities

              for (let j = 0; j <  allAssets[i].assetLiabilities.length; j++) {//loop through associated liabilities
                distinctLiabilities.push( allAssets[i].assetLiabilities[j])
              }

            }
          } else {
            let row = JSON.parse(JSON.stringify(ociAssetLiabilitiesRow)); //create row object
            row.asset =  allAssets[i]; //assign asset value in row
            let addresses = applicant.personProfile.addresses;
            let subjectOfLoan = allAppApps[applicantIndex].loanApplication.projectAssets.find(item =>
              (item.considerationType === "unit" || item.considerationType === "package"));

            if (allAssets[i].assetLiabilities.length > 0) { //check if there are associated liabilities

              for (let j = 0; j < allAssets[i].assetLiabilities.length; j++) {//loop through associated liabilities
                if (allAssets[i].assetLiabilities[j].liabilityType !== "Rent" && allAssets[i].assetLiabilities[j].paymentType === "") {
                  allAssets[i].assetLiabilities[j].paymentType = "3% of Balance"
                } else if (allAssets[i].assetLiabilities[j].liabilityType === "Rent") {
                  allAssets[i].assetLiabilities[j].paymentType = "Add Payment"
                  //find any existing "rent at current address" within assetliabilities and set dynamic
                  if (allAssets[i].assetLiabilities[j].liabilityDescription === "Rent at Current Address") {
                    for (let k = 0; k < addresses.length; k++) {
                      if (addresses[k].addressStatus === "Current" && addresses[k].residenceStatus === "Rent"
                        && JSON.parse(addresses[k].monthlyPayments) === allAssets[i].assetLiabilities[j].monthlyPaymentAmount
                        && subjectOfLoan.occupancy === "Rental" && dynamicRentFound === false) {
                        dynamicRentFound = true;
                        row.options.dynamic = true;
                        break
                        }
                      }
                    }
                }
                row.liabilities.push({
                  liability: allAssets[i].assetLiabilities[j],
                  liabilityOptions: {expand: false}
                });//add liability to liabilities array
                distinctLiabilities.push(allAssets[i].assetLiabilities[j])
              }
            }
            row.asset.assetLiabilities = [];
            ociAssetsLiabilities.push(row);//add row into array of ociAssetsliabilities
          }
        }
      }
      if (applicant.liabilities) {
        let allLiabilities = JSON.parse(JSON.stringify(applicant.liabilities));
        // this.ociLog("Liabilities From State",applicant.liabilities)
        // this.ociLog("allLiabilities ",allLiabilities)
        //Loop and add liabilities to ociAssetLiabilities

        for (let i = 0; i < allLiabilities.length; i++) {
          let duplicateLiability = false;
          for (let k = 0; k < distinctLiabilities.length; k++) {
            // this.ociLog("LOOP -- "+k)
            if (distinctLiabilities[k].liabilityId === allLiabilities[i].liabilityId) {
              // this.ociLog("MATCH prev")
              duplicateLiability = true;
              break;
            }
          }
          // this.ociLog("duplicateLiability -- ",duplicateLiability)
          if (duplicateLiability === false) {
            let row = JSON.parse(JSON.stringify(ociAssetLiabilitiesRow));
            let addresses = applicant.personProfile.addresses;
            let subjectOfLoan = allAppApps[applicantIndex].loanApplication.projectAssets.find(item =>
              (item.considerationType === "unit" || item.considerationType === "package"));
            if (allLiabilities[i].liabilityType !== "Rent" && allLiabilities[i].paymentType === "") {
              allLiabilities[i].paymentType = "3% of Balance"
            } else if (allLiabilities[i].liabilityType === "Rent") {
              allLiabilities[i].paymentType = "Add Payment"
            //find any existing "rent at current address" and set dynamic to true
              if (allLiabilities[i].liabilityDescription === "Rent at Current Address") {
                for (let j = 0; j < addresses.length; j++) {
                  if (addresses[j].addressStatus === "Current" && addresses[j].residenceStatus === "Rent"
                    && JSON.parse(addresses[j].monthlyPayments) === allLiabilities[i].monthlyPaymentAmount
                    && subjectOfLoan.occupancy === "Rental" && dynamicRentFound === false) {
                    row.options.dynamic = true;
                    dynamicRentFound = true;
                    break
                    }
                  }
                }
            }
            row.liabilities.push({liability: allLiabilities[i], liabilityOptions: {expand: false}});
            ociAssetsLiabilities.push(row);
          }
        }
      }
      // console.log("updating assets and liabilities...")
        // this.ociLog("UPDATING updateAssetsLiabilitiesState------",ociAssetsLiabilities)
        //transforming back into correct format for state and pushing to state
        /* if (promptAppSave === 'no') {
          this.$store.commit('PROMPT_MTG_APP_SAVE', false)
        } else {
          this.$store.commit('PROMPT_MTG_APP_SAVE', true)
        } */

        //transform for state
        let assetsForState = [];
        let liabilitiesForState = [];

        for (let i = 0; i < ociAssetsLiabilities.length; i++) {
          if (ociAssetsLiabilities[i].asset !== null) {
            //Add asset to variable for state
            let assetCopy = JSON.parse(JSON.stringify(ociAssetsLiabilities[i].asset));
            if(assetCopy.downPayment!==null ){
              assetCopy.downPayment.detail =  assetCopy.assetType ;
            }
            assetsForState.push(assetCopy);
            //Add related liabilities to newly-pushed asset
            for (let j = 0; j < ociAssetsLiabilities[i].liabilities.length; j++) {
              let liability = JSON.parse(JSON.stringify(ociAssetsLiabilities[i].liabilities[j].liability));
              liability.path = 'assets/'+(assetsForState.length - 1)+'/assetLiabilities/'+j;
              assetsForState[assetsForState.length - 1].assetLiabilities.push(liability)
            }
          } else {
            //If no asset, just add liabilities
            for (let k = 0; k < ociAssetsLiabilities[i].liabilities.length; k++) {
              let liability = JSON.parse(JSON.stringify(ociAssetsLiabilities[i].liabilities[k].liability));
              liability.path = 'liabilites/'+k;
              liabilitiesForState.push(liability)//if no asset it has only one liability;
            }
          }
        }

        // console.log(liabilitiesForState);
        //add properties to other assets
        assetsForState = assetsForState.concat(properties);
        // assetsForState.sort((a, b) => (a.assetId > b.assetId) ? 1 : -1);
        allAppApps[applicantIndex].applicant.assets = assetsForState;
        allAppApps[applicantIndex].applicant.liabilities = liabilitiesForState;


       /*  let applicant = JSON.parse(JSON.stringify(applicant));
        applicant.assets = assetsForState;
        applicant.liabilities = liabilitiesForState;
        this.$store.commit('UPDATE_APPLICANT_IN_ARRAY', {index: applicantIndex, applicant: applicant});
        this.$forceUpdate(); */
      }
      // store.commit('ALL_APPLICATION_APPLICANTS', allAppApps);
      return allAppApps;
    },
    //MAY ABANDON Use this when html content e.g. when rendering html from data field
    objectTruthFinder(obj) {
      // assume obj never has empty object or array
      for (let [key, value] of Object.entries(obj)) {
        if (typeof(obj[key])=='object' && !obj[key].isArray) {
          if (this.objectTruthFinder(obj[key])) {
            return true;
          }
        } else if(obj[key].isArray ) {
          // [1,2,3]
          obj[key].forEach(index => {
            if (typeof(obj[key][index])=='object') {
              if (this.objectTruthFinder(obj[key][index])) {
                return true;
              }
              } else {
                if (obj[key][index]) {
                  return true;
                }
              }
            }
          )
        } else {
          if (obj[key] && typeof(obj[key])=='boolean') {
            return true;
          }
        }
      }
    },
    // needs work, could be useful - maybe try JSON.stringify(obj, sort(...)) on each level
    objectCompare(obj1 , obj2) {
      console.log(obj1)
      console.log(obj2)
      // order of properties must be same for objects to be equal
      // first check if sizes and type are the same
      if (typeof(obj1) == typeof(obj2) && obj1.length == obj2.length) {
        // sizes and type are same, look deeper
        console.warn(obj1 + ' ...sizes and types are same')
        if (typeof(obj1) == 'object' && !obj1.isArray) {
          console.warn(obj1 + ' ...is object')
          // case 1 arguments are objects, iterate and feed back through function
          for (let [key,value] of Object.entries(obj1)) {
              if (!this.objectCompare(obj1[key],obj2[key])) {
                console.warn('object EXIT: due to ' + obj1[key] + '  and  ' + obj2[key])
                return false
              }
          }
        } else if (obj1.isArray) {
          console.warn(obj1 + ' ...is array')
          // case 2 arguments are arrays, feed through function again
          obj1.forEach(index => {
            if (!this.objectCompare(obj1[index],obj2[index])) {
              console.warn('array EXIT: due to ' + obj1[index] + '  and  ' + obj2[index])
              return false
            }
          })
        } else {
          // last case, arguments are field level, check for equality
          console.warn(obj1 + ' ...is field')
            if (obj1 != obj2) {
              console.warn('field EXIT: due to ...' + typeof(obj1) + '  and  ' + typeof(obj2))
              return false
            } else {
              return true
            }
          // if a single comparison is false, the whole thing is false
        }
      } else {
        // sizes or type are different immediately return false
        return false
      }

    },
    ociEncode(value){
      if(value){
        value = value.replace('&', '&amp;');
        value = value.replace('<', '&lt;');
        value = value.replace('>', '&gt;');
        value = value.replace('"', '&quot;');
        value = value.replace('\'', '&#x27;');
        value = value.replace('/', '&#x2F;');
      }
      return value;
    },
    showSwal(msg) {

      swal({
        title: msg.title,
        text: msg.text,
        type: msg.type,
        timer: msg.timer,
      })
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    arrayIsEmptyOrEmptyObject(arrayParam) {
      if (arrayParam) {
        if (arrayParam.length > 0) {
          return this.isEmpty(arrayParam[0])
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }
    },

    formatCountdown(count){
      let minutes = Math.trunc(count / 60).toString(10);
      let seconds = (count % 60).toString(10);
      let minuteFormat = "00";
      let secondsFormat = "00";
      let countDownFormat="";
      if(minutes.length  === 1 && minutes!== "0"){
        minuteFormat =  "0"+minutes;
      }
      else if(minutes.length  > 1){
        minuteFormat =   minutes;
      }
      if(seconds.length === 1 && seconds !== "0"){
        secondsFormat = "0"+seconds
      }
      else if (seconds.length>1){
        secondsFormat = seconds
      }
      countDownFormat = minuteFormat+":"+secondsFormat;
      return countDownFormat;
    },

    /**
     * Returns the name of the vue component that triggered the first programmed function call
     * within the context of this function's stack
     * @returns {string}
     */
    getCallerName: function()
    {
      try{
        //Create but do not throw an error
        const e = new Error();

        // Try to find a Vue caller name
        const vueMatches = e.stack.match(/\/[a-zA-Z]+\.vue/);
        if(vueMatches){
          if (vueMatches[0]){
            return vueMatches[0].slice(1, vueMatches[0].length);
          }else{
            return "Unknown File";
          }
        }else{
          return "Unknown File"
        }
      }catch(error){
        return "";
      }
    },
    /**
     * Performs a this.ociLog() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvLog: function(...args)
    {
      //Log based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        const callerName = this.getCallerName();
        // console.log(callerName + " logs:", ...args);
      }
    },
    /**
     * Performs a console.assert() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvAssert: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.assert(...args);
      }
    },
    /**
     * Performs a console.debug() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvDebug: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        const callerName = this.getCallerName();
        console.debug(callerName + " debugs:", ...args);
      }
    },
    /**
     * Performs a console.error() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvError: function(...args)
    {
      // Iterate based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        const callerName = this.getCallerName();
        console.error(callerName + " reports:", ...args);
      }
    },
    /**
     * Performs a console.group() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvGroup: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.group(...args);
      }
    },
    /**
     * Performs a console.groupEnd() with some input parameters if the current app environment is local development or deploy test
     */
    ociEnvGroupEnd: function()
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.groupEnd();
      }
    },
    /**
     * Performs a console.info() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvInfo: function(...args)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        const callerName = this.getCallerName();
        console.info(callerName + " informs:", ...args);
      }
    },
    /**
     * Performs a console.table() with some input parameters if the current app environment is local development or deploy test
     * @param tabularData - An iterable containing strings and/or objects to be logged
     */
    ociEnvTable: function(tabularData)
    {
      //warn based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.table(tabularData);
      }
    },
    /**
     * Performs a console.trace() with some input parameters if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvTrace: function(...args)
    {
      //trace based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        console.trace(...args);
      }
    },
    /**
     * Performs a console.warn() with some input parameters and prints a stack trace if the current app environment is local development or deploy test
     * @param args - An iterable containing strings and/or objects to be logged
     */
    ociEnvWarn: function(...args)
    {
      // Iterate based on scope
      let env = process.env.NODE_ENV;
      if(env === 'development' || env === 'deploy-test'){
        const callerName = this.getCallerName();
        console.warn(callerName + " warns:", ...args);
      }
    },

  },
  regex:{
    invalidEmail(email) {
      if (email) {
        let pattern = (/(^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$|^$)/)
        return pattern.test(email)
      }
    },
    validString(str) {
      if (str) {
        // check inputValidation.java to see if this is up to date
        let pattern = new RegExp("^[a-zA-Z 0-9'-\\.,+@%$!&%_()/]*$")
        return pattern.test(str)
      }
    },
    applyMinimumReqRegex(pass){
      let minimumPattern = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?"!@#%&/\\,><':;|_~`\\-]).+$/
      return minimumPattern.test(pass)
    },
    onlyAllowedPattern(pass){
      let onlyAllowedPattern = /[\w+=^$*.\[\]{}()?"!@#%&/\\,><':;|_~`\\-]{9,80}/
      return onlyAllowedPattern.test(pass)
    },
  },
  broker: {
    pdfViewer(response){
      if(!response){
        console.warn("getPDF Error Occurred");
      }
      else {
        const blob = new Blob([response.data], {type: "application/pdf"});
        const url = URL.createObjectURL(blob);
        window.open(url);

        /**
         * Please donot remove the commented iframe code
         */
        /*let x = window.open();
          x.opener = null;
        x.referrer = null;
        let iframe = x.document.createElement('iframe');
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.style = "border: 0";
        iframe.src = url;
        x.document.title = "OneClose Forms";
        x.document.body.appendChild(iframe);*/
      }
    },

    imageViewer(response){
      if(!response){
        console.warn("getPDF Error Occurred");
      }
      else {
        const blob = new Blob([response.data], {type: "image/png"});
        const url = URL.createObjectURL(blob);
        window.open(url);


        /**
         * Please donot remove the commented iframe code
         */
        /* let x = window.open();
         let iframe = x.document.createElement('iframe');
         iframe.width = '100%';
         iframe.height = '100%';
         iframe.style = "border: 0";
         iframe.src = url;*/
        // x.document.title = "OneClose Forms";
        // x.document.body.appendChild(iframe);
      }
    },
    saveToComputer(response, fileName){
      if(!response){
        console.warn("getPDF Error Occurred");
      }
      else {
        const blob = new Blob([response.data], {type: "image/png"});
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName;
        link.click();
      }
    },

    calculateMortgagePayment(loanApplication, interest) {
      //ensure required variables for calculation are present and data is of valid type
      let variablesPresent =  [];
      let runCalculation = true;
      // this.ociLog("Mortgage object interest",loanApplication.mortgage.interestRate)
      // this.ociLog("Mortgage param interest",interest)
      // this.ociLog("Mortgage amortizationMonths",loanApplication.mortgage.amortizationMonths)
      // this.ociLog("Mortgage totalLoanAmount",loanApplication.mortgage.totalLoanAmount)
      // this.ociLog("Mortgage paymentFrequency",loanApplication.mortgage.paymentFrequency)
      let interestRate;
      if(this.isRealNumber(interest)){
        interestRate = interest;
      }
      else {
        interestRate = loanApplication.mortgage.interestRate;
        // console.log(interestRate);
      }
      variablesPresent.push(this.isRealNumber(interestRate))
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.amortizationMonths) && loanApplication.mortgage.amortizationMonths> 0)
      variablesPresent.push(this.isStringValue(loanApplication.mortgage.paymentFrequency))
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.totalLoanAmount))

      for(let i=0; i<variablesPresent.length;i++){
        if (variablesPresent[i]===false){
          runCalculation=false}
      }
      // this.ociLog("Required Variables Present "+variablesPresent)
      if(runCalculation){


        let paymentFrequency = this.paymentsPerYear(loanApplication.mortgage.paymentFrequency);

        let totalInterestPeriods = paymentFrequency *(12* Number( loanApplication.mortgage.amortizationMonths));
        interestRate = interestRate / 100;
        let periodicInterestRate = 0;
        let payment=0;
        //accelerated by weekly payments use monthly interest periods and divides the payment by 2
        if(loanApplication.mortgage.paymentFrequency === "Acc-biweekly"){
          periodicInterestRate = (Math.pow((1+(interestRate/2)), (1/6))) - 1;
          totalInterestPeriods = Number(loanApplication.mortgage.amortizationMonths);
          payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods)))));
          payment = (payment / 2).toFixed(3);
        }
        //accelerated weekly payment use monthly interest periods and divides the payment by 4
        else if (loanApplication.mortgage.paymentFrequency === "Acc-weekly") {
          periodicInterestRate = (Math.pow((1+(interestRate/2)), (1/6))) - 1;
          totalInterestPeriods = Number(loanApplication.mortgage.amortizationMonths);
          payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods)))));
          payment = (payment / 4).toFixed(3);
        }
        else {
          periodicInterestRate = (Math.pow((1+(interestRate/2)), (2/paymentFrequency))) - 1;
          payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods))))).toFixed(3);
        }
        if(this.isRealNumber(payment)){
          // return _.ceil(payment, 2);
          return _.round(payment, 2);
        }
        else {
          return null;
        }

      }
      else {
        return null;
      }
      // this.updateNetMonthlyIncome(num);
      // this.updateSubjectOfLoanState();
    },
    /**
     *
     * @param loanApplication
     * @param interest
     * @param clientFees
     * @returns {null|number}
     */
    calculateAPR(loanApplication, interest, clientFees){
      if(loanApplication == null){
        return null;
      }

      //ensure required variables for calculation are present and data is of valid type
      let variablesPresent =  [];
      let runCalculation = true;
      let interestRate;
      if(this.isRealNumber(interest)){
        interestRate = interest;
      }
      else {
        interestRate = loanApplication.mortgage.interestRate;
      }
      variablesPresent.push(this.isRealNumber(interestRate));
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.amortizationMonths) && loanApplication.mortgage.amortizationMonths> 0);
      variablesPresent.push(this.isStringValue(loanApplication.mortgage.paymentFrequency));
      variablesPresent.push(this.isRealNumber(loanApplication.mortgage.totalLoanAmount));

      for(let i=0; i<variablesPresent.length;i++){
        if (variablesPresent[i]===false){
          runCalculation=false}
      }
      if(runCalculation){

        /*APR is always calculated based on monthly payments*/
        let paymentFrequency = 12;
        let totalInterestPeriods = paymentFrequency * Number(loanApplication.mortgage.amortizationMonths/12);
        interestRate = interestRate / 100;
        let periodicInterestRate = 0;
        let payment=0;

        /*Calculating the periodic interest rate*/
        periodicInterestRate = (Math.pow((1+(interestRate/2)), (2/paymentFrequency))) - 1;
        /*Calculating the monthly mortgage payment*/
        payment = ((loanApplication.mortgage.totalLoanAmount*periodicInterestRate)/(1-(Math.pow((1+periodicInterestRate),(-1 * totalInterestPeriods))))).toFixed(3);


        /*AMortizatoin Calcs*/

        let termMonths = loanApplication.mortgage.termMonths; //TODO: Term is in months in the backend; column label is incorrect
        let balance = loanApplication.mortgage.totalLoanAmount;
        let endingBalance= 0;
        let principal = 0;
        let period = 0;     //How many periods have elapsed

        let totalPrincipalOverTerm = 0;
        let totalInterestOverTerm = 0;


        /*Calculating payments for every month*/
        for(let i = 0; i < termMonths ;i++){
          endingBalance = balance;

          //accounts for the final payment of the am schedule, paying off that balance with interest on it
          if(endingBalance < Number(payment)) {
            totalInterestOverTerm += Number((endingBalance * periodicInterestRate).toFixed(2));
            principal = endingBalance;
            period = i + 1;
            payment = (Number(interest) + Number(principal)).toFixed(2);
            balance = 0;
          }else {
            totalInterestOverTerm += Number( (endingBalance * periodicInterestRate).toFixed(2) );
            principal = (Number(payment) - (endingBalance * periodicInterestRate)).toFixed(2);
            period = i + 1;
            balance = (endingBalance - principal).toFixed(2);
            totalPrincipalOverTerm += Number(balance);
          }

          if(endingBalance === 0) {
            break;
          }

        }

        /*Calculating Total Fees*/
        let totalFees = 0;
        if(Array.isArray(clientFees)) {
          for (let i = 0; i < clientFees.length; i++) {
            if(clientFees[i].includeInAPR){
              totalFees += clientFees[i].feeAmount;
            }
          }
        }

        /*Calculation APR
          APR = C/(Term in years/Average Prin)
          C = total interest for the 60 month term + Fees
          Term term in Years
          Avg Prin = Sum of principal over term/term months
        * */

        let APR =  (Number( (totalInterestOverTerm + totalFees)/ ( (termMonths/12) * (totalPrincipalOverTerm/termMonths) ) ) * 100).toFixed(3);
        return Number(APR);

      }
      else {
        return null;
      }

    },
    paymentsPerYear(frequency){
      var divider = 1;
      if(frequency === "Monthly"){
        divider = 12;
      }
      if(frequency === "Semi-monthly"){
        divider = 24;
      }
      if(frequency === "Weekly"){
        divider = 52;
      }
      if(frequency === "Bi-weekly"){
        divider = 26;
      }
      if(frequency === "Acc-weekly"){
        divider = 52;
      }
      if(frequency === "Acc-biweekly"){
        divider = 26;
      }
      if(frequency === "Annually"){
        divider = 1;
      }
      if(frequency === "Semi-annually"){
        divider = 2;
      }
      if(frequency === "Quarterly"){
        divider = 4;
      }
      return divider;
    },
    /**
     Ensure value is a number and  not boolean, not empty string, not infinite
     */
    isRealNumber(value){
      return !isNaN(parseFloat(value)) && isFinite(value) && value
    },
    /**
     Ensure value is string, not null, not empty and not undefined
     */
    isStringValue(value){
      if(value!== null && value !== '' && typeof value!=='undefined')
      {return  true}
      else {return false}
    }
  },

  string:{
    stringToBool(val) {
      // options element converts boolean to string even if declared boolean in dropdowns.js
      // empty string converts to null
      if (val.length>0) {
        return val==='true'? true : false
      } else {
        return null
      }
    },
    stringToNum(val) {
      // empty string converts to null
      if (val.length>0 && !isNaN(val)) {
        return Number(val)
      } else {
        return null
      }
    },
    /**
     Ensure value is string, not null, not empty and not undefined
     */
    isStringValue(value){
      if(value!== null && value !== '' && typeof value!=='undefined')
      {return  true}
      else {return false}
    },
    /**
     * Remove preceding and trailing whitespace from a string
     * @param string - gets converted to a string if not a string
     * @returns string without outer whitespace
     */
    trimSpace(string){
      if(string){
        string = string.toString();
        //Remove preceding and trailing whitespace
        string = string.trim();
      }
      return string;
    },
    /**
     Formats date from yyyy-dd-mm  or yyyy/mm/dd to mm-dd-yy
     */
    formatYYMMDDToMMDDYY(dateString){
      let formattedDate = dateString.substr(5,2)+"-"+ dateString.substr(8,2)+"-"+dateString.substr(0,4);
      return formattedDate;
    },
    /**
     Strips out all non numbers from phone number string then formats into this format xxx xxx xxxx
     */
    formatPhoneNumberSpaces(number){
      //console.log(number.match(/\d+/g).map(Number).join(""));
      let numbersOnly = number.replace(/[^\d]/g, '').replace(/^0+/, '');
      //trim number of digits if excess of 10
      if(numbersOnly.length>10){
        numbersOnly =  numbersOnly.slice(-10);      }
      return numbersOnly.substr(0,3)+" "+numbersOnly.substr(3,3)+" "+numbersOnly.substr(6,4);
    },
    isValidDate(date) {
      return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
    },
    convertToSentence(val) {
      return _.startCase(val);
    }
  },


  messaging: {
    generateChatId: function (){
      let date = new Date();
      let timestamp = date.getTime();
      let randomStart= Math.random().toFixed(4).split('.')[1];
      let uniqueNumber = +randomStart+timestamp;
      return uniqueNumber;
    },
    //format sent time
    formatChatTime: function (dateTime){
      // apply rules for am or pm and adjusting javascript zero  starting and adding 0 to months, minutes, dates etc
      let month = (dateTime.getMonth()+1)
      let date = dateTime.getDate()
      let hour =dateTime.getHours()
      let minutes = dateTime.getMinutes()
      let dateZero='';
      let minuteZero='';
      let monthZero='';

      let meridiem = '';
      // logic for adding am or pm
      if (hour >11){
        meridiem='pm'
        if(hour>12){
          hour = hour-12;
        }
      }
      else {meridiem='am'}
      //logic for adding zeros
      if (date<10){dateZero='0'}
      if (minutes<10){minuteZero='0'}
      if(month<10){monthZero='0'}
      // create date string

      let formatedDateTime =
        dateZero+date+'/'+monthZero+month+'/'+dateTime.getFullYear()+' '
        +hour+':'+minuteZero+minutes+' '+meridiem;
      return formatedDateTime;
    },
    orderMessagesBySentTime(messages){
      messages.sort(function(a,b) {
          let comparison= 0;
          let aUpdate = a.sentTime
          let bUpdate = b.sentTime
          if (aUpdate>bUpdate){
            comparison = 1;
          }
          else if (aUpdate<bUpdate){
            comparison = -1;
          }
          return comparison;
        }
      )
    }
  },
  appState:{
    saveAppStateLocalStorage(state, currentPage){
      let userId = store.getters.appUser.userId
      let stringState = JSON.stringify(state);
      let encryptedState =  crypto.encryptData(stringState)
      localStorage.setItem("app-d"+userId,encryptedState)
      let userData = JSON.stringify({lastPage:currentPage,userId:userId,appReload:true})
      let encryptedUserData =  crypto.encryptData(userData)
      localStorage.setItem("user-d"+userId,encryptedUserData)
    },
    cleanAppStateReload(){
      let userId = store.getters.appUser.userId
      localStorage.removeItem("app-d"+userId);
      localStorage.removeItem("user-d"+userId);

    },
    //deprecated since using session management techniques
    loadAppStateLocalStorage(){
      let userId = store.getters.appUser.userId
      let encryptedAppState =  localStorage.getItem("app-d"+userId);
      let localAppState = JSON.parse(crypto.decryptData(encryptedAppState))
      localAppState.appUser=store.getters.appUser;
      localAppState.userToken=store.getters.userToken;
      store.replaceState(localAppState);
    },
    /**
     * Used to remove from user's localStorage previous data stored there but now is store in session Storage.
     */
    clearDeprecatedData(){
      let userId = store.getters.appUser.userId
      localStorage.removeItem("user-token");
      localStorage.removeItem("profilePicturePath");
      localStorage.removeItem("user-d0");
      localStorage.removeItem("app-d0");
      localStorage.removeItem("app-d"+userId);
      localStorage.removeItem("user-d"+userId);
    }

  }

};

export default ociUtils

/**
 * This is defined and exported here to provide an easily accessible logging function outside of the Vue object scope.
 * Including this here allows files without access to the Vue mixin (such as regular .js files)
 * to use the same logging convention.
 * @param args - An iterable containing items to be printed
 */
export function ociLog(...args){
  ociUtils.global.ociEnvLog(...args);
}

/**
 * This is defined and exported here to provide an easily accessible logging function outside of the Vue object scope.
 * Including this here allows files without access to the Vue mixin (such as regular .js files)
 * to use the same logging convention.
 * @param args - An iterable containing items to be printed
 */
export function ociError(...args){
  ociUtils.global.ociEnvError(...args);
}
